var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConnect = function SvgConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 1.3c-.4-.4-1-.4-1.4 0l-1.6 1.6c-2.1-1.5-4.8-1.1-6.7.9l-.8.7c-.3.3-.3.8 0 1.2l6.2 6.1c.3.3.8.3 1.2 0l.6-.6c2-1.9 2.4-4.7.9-6.9l1.6-1.6c.4-.4.4-1 0-1.4zM10.3 11.3l-1.8 1.8-1.6-1.6 1.8-1.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1.9 1.9-.9-1c-.3-.3-.8-.3-1.2 0l-.5.6c-2 1.9-2.4 4.7-.9 6.9L.3 18.3c-.4.4-.4 1 0 1.4s1 .4 1.4 0l1.6-1.6c2.1 1.5 4.8 1.1 6.7-.9l.7-.7c.3-.3.3-.8 0-1.2l-.9-.8 1.8-1.8c.4-.4.4-1 0-1.4s-.9-.4-1.3 0z"
  })));
};
export default SvgConnect;